import {
  LEGACY_GALLERY_TRANSPARENT_PIXEL,
  type LegacyGalleryItem,
} from '@/components/legacy-gallery/legacyGalleryTypes';

export const LEGACY_PORTRAIT_TRANSPARENT_PIXEL: string =
  LEGACY_GALLERY_TRANSPARENT_PIXEL;

export interface LegacyPortraitGalleryItem extends LegacyGalleryItem {
  [key: string]: unknown;
  aspectRatio?: number;
  isGenerated?: boolean;
  isRetrying?: boolean;
  retryCount?: number;
  uuid: string;
}

export interface LegacyPortraitGalleryApi {
  canScroll: () => boolean;
  isItemVisible: (uuid: string) => boolean;
  scrollToItem: (uuid: string) => void;
}

export function getLegacyPortraitImageSource(
  portrait: LegacyPortraitGalleryItem
): string {
  return portrait.isPreloaded !== false && portrait.url
    ? portrait.url
    : LEGACY_PORTRAIT_TRANSPARENT_PIXEL;
}
